import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, ShopifyOrderColumns, TaskListingColumns, TaskListingSellerColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import DatePickerComponent from "../common/DatePickerComponent";
import { getAllTaskListing } from '../../store/actions/picker.action';
import LoaderSpinner from '../common/Loader';

/*istanbul ignore next */
const ShopifyOrders = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    let dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.user);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        sellerIdList: [],
        companyIdList: [],
        showFilter: false,
        showSearch: false,
        startDate: null,
        endDate: null,
    }

    const [filterData, setfilterData] = useState(dataLoad);
    const { allTaskList, allTaskListStatus } = useSelector((state) => state.pickerReducer);
    const [allTasksList, setAllTasksList] = React.useState([]);

    useEffect(() => {
        getAllTasksList();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder, endDate]);

    const getAllTasksList = () => {
        let data = { ...filterData, startDate: startDate ? moment(startDate).format('YYYY-MM-DDT00:00:00') : null, endDate: endDate ? moment(endDate).format('YYYY-MM-DDT23:59:59') : null };
        dispatch(getAllTaskListing(data));
    }

    const getStatusClass = (status) => {
        switch (status) {
            case 'Hold':
                return 'activeStatus activeStatusRefunded';
            case 'In-Progress':
                return 'activeStatus taskInprogress';
            case 'Pending':
                return 'activeStatus activeStatusInprogress';
            case 'Completed':
                return 'activeStatus';
            case 'Canceled':
                return 'activeStatus activeStatusCanceled';
            default:
                return 'activeStatus uploads';
        }
    };

    useEffect(() => {
        if (allTaskListStatus === 'PENDING') {
            setLoader(true);
        } else if (allTaskListStatus === 'SUCCESS') {
            const enrichedList = allTaskList.listTasks.map(item => ({
                ...item,
                listIndex: item.id,
                taskStatusName: `<span class="${getStatusClass(item.taskStatusName)}">${item.taskStatusName}</span>`
            }));
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(allTaskList?.TotalRecords / filterData.pageSize),
            });
            setAllTasksList(enrichedList);
            setLoader(false);
        }
    }, [allTaskListStatus]);

    const handleAction = (item, type) => {
        navigate(`/tasks/${item.id}`, {
            state: {
                data: item,
                editable: type === 'view' ? false : true,
            },
        });
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handleNavigate = () => {
        navigate(`/tasks/0`, {
            state: {
                data: {},
                editable: true,
            },
        });
    }

    const handleDateChange = (date) => {
        setDateRange(date);
    }

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec zIndex2">
                    <span>Shopify Orders</span>
                    <div className="top_right_button_container">
                        <div className="pickHead">
                            <div className="fontFix mr-3">
                                <DatePickerComponent
                                    className="date-picker form-control pr-4"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        handleDateChange(update);
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    isClearable={true}
                                    showIcon={false}
                                    popperPlacement="top-end"
                                    placeholderText="Select Date Range"
                                    maxDate={new Date()}
                                />
                            </div>
                            {!userDetails?.Value?.isSuperAdmin && (
                                <button
                                    className="btn cus-seconday-bg-btn top-btn"
                                    onClick={handleNavigate}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i> Create New
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {loader && (<div className="full-screen-spinner-overlay zIndex2"><LoaderSpinner /></div>)}
                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl">
                            {allTaskListStatus === 'SUCCESS' && (
                                <DataTable
                                    headers={ShopifyOrderColumns}
                                    tableData={allTasksList}
                                    actionType={3}
                                    handleAction={handleAction}
                                    handleSortingColumn={handleSortingColumn}
                                    tableDataStatus={allTaskListStatus}
                                    filterData={filterData}
                                />
                            )}
                        </div>
                    </div>
                    <BatchPagination
                        gridData={allTasksList}
                        totalVisualRecords={allTasksList?.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={loader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={allTaskList?.TotalRecords || 0}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                    />
                </div>
            </div>
        </main>
    );
}

export default ShopifyOrders;